import React from 'react';
import { AspectRatioToken, BorderRadiusTokens, ButtonTypeTokens, ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, LikeStateTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TypographyTypeTokens, } from '@voltmoney/schema';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Button from '../button/Button';
import Image from '../image/Image';
import Divider from '../divider/Divider';
import Icon from '../icon/Icon';
const NewsCard = ({ padding = {
    top: SizeTypeTokens.NONE,
    horizontal: SizeTypeTokens.NONE,
    bottom: SizeTypeTokens.MD,
}, margin = {
    bottom: SizeTypeTokens.XL,
}, bgColor = ColorTokens.Grey_600, borderRadius = BorderRadiusTokens.BR1, imageURL, title, subtitle, source, timeStamp, likeState, onPress, likeAction, discussAction, discussActionLabel, MoreAction, triggerAction, action, onPressLike, onPressDiscuss, onPressMore, }) => {
    if (!title)
        return React.createElement(React.Fragment, null);
    const handleAction = () => {
        onPress && onPress();
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(Card, { bgColor: bgColor, borderRadius: borderRadius, onPress: handleAction, padding: padding, margin: margin, header: {
            children: imageURL ? (React.createElement(Image, { uri: imageURL, size: ImageSizeTokens.FULL, aspectRatio: AspectRatioToken.A16_9, borderTopRadius: borderRadius })) : (React.createElement(React.Fragment, null)),
        }, body: {
            children: (React.createElement(Card, { padding: { horizontal: SizeTypeTokens.LG }, body: {
                    children: [
                        React.createElement(Space, { size: SizeTypeTokens.LG }),
                        React.createElement(Typography, { label: title, type: TypographyTypeTokens.H5, numberOfLines: 2 }),
                        React.createElement(Space, { size: subtitle
                                ? SizeTypeTokens.MD
                                : SizeTypeTokens.NONE }),
                        subtitle ? (React.createElement(Typography, { label: subtitle, type: TypographyTypeTokens.B6, color: ColorTokens.Grey_200, numberOfLines: 2 })) : (React.createElement(React.Fragment, null)),
                        React.createElement(Space, { size: source && source?.title
                                ? SizeTypeTokens.LG
                                : SizeTypeTokens.NONE }),
                        source && source?.title ? (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center },
                            React.createElement(Image, { uri: source?.image, size: ImageSizeTokens.XXS, borderRadius: BorderRadiusTokens.BR1 }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Typography, { label: source?.title, type: TypographyTypeTokens.B7 }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Icon, { name: IconTokens.Dot, size: IconSizeTokens.XXS, color: ColorTokens.Grey_300 }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(Typography, { label: timeStamp, type: TypographyTypeTokens.B7, color: ColorTokens.Grey_200 }))) : (React.createElement(React.Fragment, null)),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.SM }, color: ColorTokens.Grey_550 }),
                    ],
                }, footer: {
                    children: (React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween },
                        React.createElement(Button, { type: ButtonTypeTokens.IconGhost, onPress: () => {
                                if (onPressLike)
                                    onPressLike();
                                if (likeAction)
                                    triggerAction(likeAction);
                            }, icon: {
                                name: likeState === LikeStateTokens.SELECTED
                                    ? IconTokens.BulbFilled
                                    : IconTokens.BulbOutline,
                                size: IconSizeTokens.XXL,
                            } }),
                        React.createElement(Button, { type: ButtonTypeTokens.SmallGhost, label: discussActionLabel, icon: {
                                name: IconTokens.DoubleMessage,
                                size: IconSizeTokens.XL,
                            }, onPress: () => {
                                if (onPressDiscuss)
                                    onPressDiscuss();
                                if (discussAction)
                                    triggerAction(discussAction);
                            } }),
                        React.createElement(Button, { type: ButtonTypeTokens.IconGhost, icon: {
                                name: IconTokens.Share,
                                size: IconSizeTokens.LG,
                            }, onPress: () => {
                                if (onPressMore)
                                    onPressMore();
                                if (MoreAction)
                                    triggerAction(MoreAction);
                            } }))),
                } })),
        } }));
};
export default React.memo(NewsCard, (prevProps, nextProps) => {
    return prevProps === nextProps;
});
export { NewsCard };
